module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"agreement_text":"Работая с этим сайтом, вы даете свое согласие на использование файлов cookie. Это необходимо для нормального функционирования сайта.","learn_more_button":"Подробнее"},"en":{"agreement_text":"Our website uses cookies to ensure that we give you the best user experiences.","learn_more_button":"Learn more"}}')
  delete Component.options._Ctor
}
